// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1Ui0F","approved":"Status_approved__1jiHR","rejected":"Status_rejected__336Cl","expired":"Status_expired__2CxOl","label":"Status_label__DqXUc"};